export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/depositphotos.675981b7.svg","height":32,"width":177};